import { useContext, useState, useEffect } from "react";
import AuthContext from "../../context/authContext";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "./paginaencomenda.css";

const API_URL = "https://api.nwayami.com/api";

const PaginaEncomenda = () => {
  const { user } = useContext(AuthContext);
  const [enderecos, setEnderecos] = useState([]);
  const [pontoReferencia, setPontoReferencia] = useState("");
  const [instrucoesEntrega, setInstrucoesEntrega] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      navigate("/loginpage");
      return;
    }

    const fetchEnderecos = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/loginpage");
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/enderecos/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setEnderecos(response.data);
      } catch (error) {
        console.error("Erro ao buscar endereços:", error);
      }
    };

    fetchEnderecos();
  }, [user, navigate]);

  const handleContinuar = () => {
    if (enderecos.length === 0) {
      alert("Você precisa cadastrar pelo menos um endereço.");
      return;
    }

    const dadosEncomenda = {
      pontoReferencia,
      instrucoesEntrega,
      enderecoSelecionado: enderecos[0],
      metodoPagamento: location.state?.metodoPagamento || "Encomenda",
      cliente: {
        nome: user?.username,
        email: user?.email,
        telefone: user?.telefone,
      },
    };

    navigate("/confirmar-encomenda", {
      state: dadosEncomenda,
    });
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">📦 Dados de Encomenda</h2>

      {/* Informações do Cliente */}
      <div className="card p-3 mb-4 shadow">
        <h4>Informações do Cliente</h4>
        <p><strong>Nome:</strong> {user?.username}</p>
        <p><strong>Email:</strong> {user?.email}</p>
        <p><strong>Telefone:</strong> {user?.telefone}</p>
      </div>

      {/* Endereço de Entrega */}
      <div className="card p-3 mb-4 shadow">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h4 className="mb-0">Ponto de Entrega</h4>
          {enderecos.length > 0 && (
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => navigate("/minha-conta")}
            >
              Editar
            </button>
          )}
        </div>

        {enderecos.length > 0 ? (
          <ul className="list-group">
            {enderecos.map((endereco, index) => (
              <li key={index} className="list-group-item">
                {endereco.rua}, {endereco.cidade}, {endereco.provincia} - {endereco.pais}
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center">
            <p className="text-muted">Nenhum endereço cadastrado.</p>
            <button
              className="btn btn-outline-success"
              onClick={() => navigate("/minha-conta")}
            >
              Adicionar Endereço
            </button>
          </div>
        )}
      </div>

      {/* Outras Informações */}
      <div className="card p-3 shadow">
        <h4>Outras Informações</h4>
        <div className="mb-3">
          <label className="form-label">Ponto de Referência</label>
          <input
            type="text"
            className="form-control"
            value={pontoReferencia}
            onChange={(e) => setPontoReferencia(e.target.value)}
            placeholder="Ex: Ao lado do mercado ABC"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Instruções para Entrega</label>
          <textarea
            className="form-control"
            value={instrucoesEntrega}
            onChange={(e) => setInstrucoesEntrega(e.target.value)}
            placeholder="Ex: Tocar a campainha duas vezes"
            rows={3}
          />
        </div>

        <button className="btn btn-success mt-2" onClick={handleContinuar}>
          Continuar
        </button>
      </div>
    </div>
  );
};

export default PaginaEncomenda;
